module.exports = __webpack_public_path__ + "img/zzjg.9625c9ff.png";